
  angular
    .module('kareo.ui.shared.directives.user.k-user-roles-table-view', [
      'kareo.ui.shared.directives.templates',
      'kareo.ui.shared.directives.user.k-user-roles-table-view.k-role-permissions',
      'kareo.ui.shared.modules.authentication.k-roles'
    ])
    .component('kUserRolesTableView', {
      bindings: {
        practiceProducts: '<'
      },
      controller,
      controllerAs: 'vm',
      template: require('./k-user-roles-table-view.pug')()
    });

  controller.$inject = ['K_ROLES', 'KRolePermissions'];
  function controller(K_ROLES, KRolePermissions) {
    const vm = this;

    vm.roles = K_ROLES;
    vm.rolePermissions;
    vm.showRolePermission = showRolePermission;
    vm.hasRole = hasRole;
    vm.isLoading = false;
    vm.init = init;

    async function init() {
      vm.isLoading = true;

      var rolePermissions = await KRolePermissions.getRolePermissions()
      vm.rolePermissions = rolePermissions

      vm.loading = false;
    }

    function hasRole(roles, role) {
      return roles.indexOf(role) > -1;
    }

    function isProductEnabled(product) {
      return vm.practiceProducts[product] && vm.practiceProducts[product].isEnabled;
    }

    // Show the permissions for the role if they have access to the product solution
    function showRolePermission(category) {
      // If the category is general or administration it should always show
      if (category === 'General' || category === 'Administration') {
        return true;
      }

      if (category === 'Clinical' && isProductEnabled('KAREO_EHR')) {
        return true;
      }

      if (category === 'Billing' && (isProductEnabled('PM') || isProductEnabled('RCM'))) {
        return true;
      }

      if (category === 'Engage' && isProductEnabled('KAREO_OFFICE')) {
        return true;
      }

      return false;
    }

    init();
  }
